<app-admin-boilerplate>
    @if (event$ | async; as lrpEvent){
        <app-event-headline [event]="lrpEvent"/>
    }
    @if (eventBooking$ | async; as eventBooking){
        <div class="mx-4 mt-6">
            <h2 [title]="'Booking ID: ' + eventBooking.bookingID">{{ eventBooking.firstName | titlecase }} {{ eventBooking.surname | titlecase}} <span class="text-gray-500 text-xs ps-3">Booking ID #{{ eventBooking.bookingID }}</span></h2>
            @if (eventBooking.originalUserId && eventBooking.originalUserId !== eventBooking.accountID){
                <small >This booking was gifted</small>
            }
            <div class="flex mt-3">
                <div class="w-1/3">
                    <app-ticket-pill [includePrice]="true" [primaryTicket]="getPrimaryTicket(eventBooking.eventTickets)" [additionalTickets]="getAdditionalTicket(eventBooking.eventTickets)"/>
                    <table class="text-xs w-full mb-3">
                        <tr>
                            <td class="w-full font-semibold">Date Booked</td>
                            <td>{{ eventBooking.bookingMade | date:'dd/MM/yyyy HH:mm'}}</td>
                        </tr>
                        @if (eventBooking.paid || eventBooking.payOnGate){
                            <tr>
                                <td class="font-semibold">Date Paid</td>
                                <td>{{ eventBooking.payment?.date| date:'dd/MM/yyyy HH:mm'}}</td>
                            </tr>
                            @if (eventBooking.paid){
                                <tr>
                                    <td class="font-semibold">Amount Paid</td>
                                    <td>{{ eventBooking.totalPaid | currency:'GBP'}}</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Payment Method</td>
                                    <td>{{ eventBooking.payment?.paymentProvider?.name }}</td>
                                </tr>
                                @if (eventBooking.payment){
                                    @for (reference of eventBooking.payment.paymentData; track $index){
                                        <tr>
                                            <td class="font-semibold">{{ reference.name }}</td>
                                            <td >{{ reference.value }}</td>
                                        </tr>
                                    }
                                }
                            }
                        }
                    </table>
                    @if (eventBooking.payment){
                        <button class="outline-button small w-full h-8 !py-0">Cancel Booking</button>
                    }
                </div>
                @if (eventSystem){
                    <div class="w-full flex gap-4 ms-3 justify-evenly">
                        <div class="w-full">
                            <app-divider label="Character Details" [large]="true"/>

                            @for (field of getCustomFields('character'); track $index){
                                @if(getCustomFieldValue(field.id)?.value){
                                    <div class="grid grid-cols-2 mx-2 my-1">
                                        <div class="font-semibold">
                                            {{ field.label }}
                                        </div>
                                        <div>
                                            @if (field.type === 'checkbox'){
                                                @if(getCustomFieldValue(field.id)?.value){
                                                    Yes
                                                }
                                                @else {
                                                    
                                                }

                                            }@else {
                                                {{ getCustomFieldValue(field.id)?.value}}
                                            }
                                            
                                        </div>
                                    </div> 
                                }
                            }
                        </div>
                        <div class="w-full">
                            <app-divider label="Player Details" [large]="true"/>
                            @for (field of getCustomFields('player'); track $index){
                                @if(getCustomFieldValue(field.id)?.value){
                                    <div class="grid grid-cols-2 mx-2 my-1">
                                        <div class="font-semibold">
                                            {{ field.label }}
                                        </div>
                                        <div>
                                            @if (field.type === 'checkbox'){
                                                @if(getCustomFieldValue(field.id)?.value){
                                                    Yes
                                                }
                                                @else {
                                                    No
                                                }

                                            }@else {
                                                {{ getCustomFieldValue(field.id)?.value}}
                                            }
                                            
                                        </div>
                                    </div> 
                                }
                            }
                        </div>
                    </div>
                }
            </div>
        </div>
    }
</app-admin-boilerplate>